import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface GenericHorizontalListCSSStyle extends UIComponentCSSStyle
{
    getGenericHorizontalListContainerCSSStyle(): object;
    getTitleCSSStyle(): object;
    getLeftArrowDivCSSStyle(paddingLeft: string): object;
    getRightArrowDivCSSStyle(paddingRight: string): object;
    getLeftArrowCSSStyle(marginTop: string, size: string): object;
    getRightArrowCSSStyle(marginTop: string, size: string): object;
    getOrderListCSSStyle(): object;
    getListCSSStyle(gutter: string): object;
}

export class GenericHorizontalListCSSStyleImpl extends UIComponentCSSStyleImpl implements GenericHorizontalListCSSStyle
{ 
    getGenericHorizontalListContainerCSSStyle(): object 
    {
        return {
            position: 'relative'
        };
    }

    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "40px",
            paddingTop: "5px",
            fontWeight: 500,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h9),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "40px",
            marginBottom: '20px',
            marginTop: '10px', 
            marginLeft: '0px',
        };
    }

    getLeftArrowDivCSSStyle(paddingLeft: string): object 
    {
       return {
               width: '40px', 
               height: '100%', 
               position: 'absolute', 
            //    display: 'flex', 
               alignItems: 'center', 
               justifyContent: 'center', 
               cursor: "pointer",
               left: paddingLeft
       };
    }

    getRightArrowDivCSSStyle(paddingRight: string): object 
    {
       return {
            width: '40px', 
            height: '100%', 
            position: 'absolute', 
            // display: 'flex', 
            cursor: "pointer",
            alignItems: 'center', 
            justifyContent: 'center', 
            right: paddingRight
        };
    }

    getOrderListCSSStyle(): object {
        return {
            listStyleType: "none",
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "row",
            overflow: "hidden",
            padding: "0px",
            margin: "0px",
        };
    }

    getLeftArrowCSSStyle(marginTop: string, size: string): object 
    {
        return {
            position: 'relative', 
            top: marginTop, 
            zIndex: 50,
            border: "none",
            height: size,
            width: size,
            cursor: "pointer",
        };
    }

    getRightArrowCSSStyle(marginTop: string, size: string): object 
    {
        return {
            position: 'relative', 
            top: marginTop, 
            zIndex: 50,
            border: "none",
            height: size,
            width: size,
            cursor: "pointer",
        };
    }

    getListCSSStyle(gutter: string): object 
    {
        return {
            paddingRight: gutter
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/generichorizontallist/genericlistcss.tsx